import { render, staticRenderFns } from "./ModalCertidaoEletronica.vue?vue&type=template&id=ee6e8fd2&"
import script from "./ModalCertidaoEletronica.vue?vue&type=script&lang=js&"
export * from "./ModalCertidaoEletronica.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertidaoEletronica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports